var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 10
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.25.5l1.463 1.364-7.257 7.784L.25 5.136l1.463-1.364 2.743 2.943z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMiIgaGVpZ2h0PSIxMCIgZmlsbD0iI2ZmZmZmZiI+CiAgICA8cGF0aCBkPSJNMTAuMjUuNWwxLjQ2MyAxLjM2NC03LjI1NyA3Ljc4NEwuMjUgNS4xMzZsMS40NjMtMS4zNjQgMi43NDMgMi45NDN6IiBmaWxsPSIjZmZmZmZmIiAvPgo8L3N2Zz4K";
export { SvgCheck as ReactComponent };